import { Controller } from "stimulus"

export default class extends Controller {
  scrollbarWidth;
  connect() {
    const scrollDiv = document.createElement('div');
    scrollDiv.className = 'overlay-scrollbar-measure';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    this.scrollbarWidth =scrollbarWidth;
    document.addEventListener('click', this.closeAll.bind(this), false);

    if(window.location.hash) {
      const hash = window.location.hash.substring(1);
      if ((hash === 'contactForm-' && this.element.dataset.open === '#mail-overlay') ||
          (hash === 'newsletter-' && this.element.dataset.open === '#newsletter-overlay')) {
        this.show(new Event('build'));
      }
    }
  }

  disconnect() {
    document.removeEventListener('click', this.closeAll.bind(this), false);
  }

  show(event) {
    event.preventDefault();

    let openElements = document.querySelector(this.element.dataset.open);
    if (openElements.classList.contains("active")) {
      openElements.classList.remove("active");
      document.body.classList.remove("overlay-open");
      openElements.style.paddingRight = 0;
    }
    else {
      let allElements = Array.from(document.querySelectorAll(this.element.dataset.close));

      for (let element of allElements) {
        element.classList.remove('active');
      }

      openElements.classList.add("active");
      document.body.classList.add("overlay-open");
      openElements.style.paddingRight = this.scrollbarWidth + 'px';
    }

    this.setBodyPadding();
  }

  toggle(event) {
    event.preventDefault();
    document.querySelector(this.element.dataset.toggle).classList.toggle("active");
    document.body.classList.toggle("overlay-open");
    this.setBodyPadding();
    let video = document.querySelector(this.element.dataset.toggle + ' #video-overlay-container');
    document.querySelector(this.element.dataset.toggle).style.paddingRight = this.scrollbarWidth + 'px';
    if (video !== null) {
      video.innerHTML = '';
    }
  }

  setBodyPadding() {
    if (document.body.classList.contains('overlay-open')) {
      document.body.style.paddingRight = this.scrollbarWidth + 'px';
    }
    else {
      document.body.style.paddingRight = 0;
    }
  }

  closeAll(event) {
    if (!event.target.matches('.js-overlay') && !event.target.matches('.call-container') && !event.target.matches('.mail-container')) return;
    event.preventDefault();

    if (document.body.classList.contains("overlay-open")) {
      let allElements = Array.from(document.querySelectorAll('.js-overlay'));

      for (let element of allElements) {
        element.classList.remove('active');
      }
      document.body.classList.remove("overlay-open");
    }
  }
}
